var React = require('react');

var Accounting = require('./Accounting');
var ChangePassword = require('./ChangePassword');
var Bandwidth = require('./Bandwidth');
var Email = require('./Email');
var Loading = require('../Loading');
var ServiceDetails = require('./ServiceDetails');
var UserStore = require('../../stores/UserStore');
var ServiceDebugger = require('../ServiceDebugger/ServiceDebugger');

var RealView = React.createClass({
    render: function () {
        if (this.props.loading || !this.props.service) {
            return <Loading />;
        }

        var service = this.props.service;
        var name = service.authentication ?
            service.authentication.username :
            service.service.name;
        var editable = UserStore.hasRole(['TECH', 'ADMIN', 'OWNER'])

        var accounting = Accounting.accountingShouldDisplay(service) ?
            <section className="powerwidget">
                <header><h2>Accounting</h2></header>
                <div className="inner-spacer">
                    <Accounting service={service} />
                </div>
            </section> : null;

        var authentication = editable && service.authentication && service.authentication.allow_password_change ?
            <section className="powerwidget">
                <header><h2>Authentication Management</h2></header>
                <div className="inner-spacer">
                    <p>
                        Your account password cannot be retrieved. If your password is
                        lost or unknown a new password must be set.
                    </p>
                    <ChangePassword service={service} />
                </div>
            </section> : null;

        var bandwidth = Bandwidth.bandwidthShouldDisplay(service) ?
            <section className="powerwidget">
                <header><h2>Bandwidth Usage</h2></header>
                <div className="inner-spacer">
                    <Bandwidth service={service} />
                </div>
            </section> : null;

        var emailAccounts = service.hosted_mail && service.hosted_mail.mailboxes > 0 ?
            <section className="powerwidget">
                <header><h2>Email Accounts <small>{service.hosted_mail.domain}</small></h2></header>
                <div className="inner-spacer">
                    <Email service={service} readOnly={!editable} />
                </div>
            </section> : null;

        var debugging = editable && service.diagnosticsAvailable ?
          <section className="powerwidget">
              <header><h2>Diagnostics</h2></header>
              <div className="inner-spacer">
                  <ServiceDebugger id={service.id} />
              </div>
          </section> : null;

        return <div className="row">
            <div className="col-md-6">
                <section className="powerwidget">
                    <header><h2>Service Details <small>{name}</small></h2></header>
                    <div className="inner-spacer">
                        <ServiceDetails service={service} upgradable={this.props.upgradable} />
                    </div>
                </section>

                {authentication}
                {emailAccounts}
            </div>
            <div className="col-md-6">
                {accounting}
                {bandwidth}
                {debugging}
            </div>
        </div>;
    },
})
module.exports = RealView;



// WEBPACK FOOTER //
// ./app/components/ClientService/RealView.js